import React from 'react';
import { twMerge } from 'tailwind-merge';
import { sanitizeNoteHtml } from './sanitizeNoteHtml';

interface SafeHtmlProps {
  html?: string;
  className?: string;
  dataTestId?: string;
}

// Read-only renderer for note HTML. white-space:pre-wrap keeps legacy plaintext (\n) notes readable while
// rendering the sanitized rich HTML that the editor now produces.
const SafeHtml: React.FC<SafeHtmlProps> = ({ html, className, dataTestId }) => {
  const sanitized = sanitizeNoteHtml(html);
  // Legacy plaintext notes keep their \n line breaks via pre-wrap; real HTML notes must NOT use pre-wrap,
  // otherwise the whitespace between block tags (server-side pretty-print) renders as spurious gaps.
  const isHtml = /<[a-z][^>]*>/i.test(sanitized);
  return (
    <div
      data-testid={dataTestId}
      className={twMerge(
        '[&_p]:m-0 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-content-brand [&_a]:underline',
        !isHtml && 'whitespace-pre-wrap',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export default SafeHtml;
